import styled from 'styled-components';

export const QuestionTextareaContainer = styled.div`
  height: 70%;
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
`;

export const QuestionSubHeading = styled.h3`
  ${(props) => props.theme.newTypography.textStyleBodySmall}
  display: flex;
  justify-content: center;
  align-items: flex-start;
  text-align: center;
  font-weight: 100;
  color: ${(props) => props.theme.newPalette.neutral.N800};
  min-height: 35px;
  font-size: 15px;
  margin: 8px 0;
  width: 100%;
`;

export const QuestionTextarea = styled.textarea`
  border: none;
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-size: 14px;
  font-weight: 100;
  background: none;
  width: 97%;
  height: 90%;
  resize: none;
  margin-top: 10px;
  line-height: 1.7;
  overflow: auto;

  &:focus {
    outline: none;
  }
`;

export const QuestionInputContainer = styled.div`
  width: 100%;
  height: 74%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
`;

export const QuestionInputHalfHeight = styled.div`
  height: 50%;
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: inherit;
  align-items: center;
`;

export const QuestionInput = styled.input`
  font-family: ${(props) => props.theme.typography.fontFamily};
  width: 97%;
  border: none;
  border-bottom: 1px solid lightgrey;
  background: none;
  padding-bottom: 10px;
  font-size: 14px;
  height: 15px;

  &:focus {
    outline: none;
  }
`;
